import * as React from "react";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { useUser } from "../state";

declare const ga: any;

export const ScrollToTop = (props: {
  children?: React.ReactNode;
}): JSX.Element => {
  const user = useUser();
  const location = useLocation();
  const gaInitialized = useRef(false);

  useEffect(() => {
    if (gaInitialized.current) {
      return;
    }

    gaInitialized.current = true;

    (function (i: any, s: any, o: any, g: any, r: any, a?: any, m?: any) {
      i["GoogleAnalyticsObject"] = r;
      ((i[r] =
        i[r] ||
        function () {
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = 1 * (new Date() as any)));
      ((a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]));
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(
      window,
      document,
      "script",
      "https://www.google-analytics.com/analytics.js",
      "ga"
    );

    ga("create", "UA-99991252-1", "auto");
  }, [user]);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Only send GA for logged in non-admin users
    if (user.type !== "logged-in" || user.user.id === 1) {
      return;
    }

    ga("send", "pageview", location.pathname);
  }, [location.pathname, user]);

  return <>{props.children}</>;
};
